jQuery(document).ready(function ($) {
    $(this).scrollTop(0);
    //Variables
    const selector = $(".slot-main .subsection-header");
    const slotFooter = $(".slot-footer");
    const subsectionLocation = $(".box-4").position().top - $(window).scrollTop() - $("#header").height() + $(".box-4").height();
    const demoSlotBox = $('.header-contents.demo');

    //Scroll function
    $(document).scroll(function () {
        if ($(document).scrollTop() >= subsectionLocation) {
            $(slotFooter).addClass("fix-top");
            $(slotFooter).css("top", $("#header").outerHeight() + $("#header").offset().top - $(window).scrollTop());
            $(selector).addClass("fix-top");
            $(selector).css("top", $("#header").outerHeight() + $(slotFooter).outerHeight() + $("#header").offset().top - $(window).scrollTop());
            $(selector).css("background", "white");
            if (demoSlotBox.length) {
                demoSlotBox.addClass('margin-top');
            }
        } else {
            $(selector).removeClass("fix-top");
            $(slotFooter).removeClass("fix-top");
            if (demoSlotBox.length) {
                demoSlotBox.removeClass('margin-top');
            }
            $(slotFooter).css("top", '');
            $(selector).css("top", '');
            $(selector).css("background", '');
        }
    })

    // Demo slots click event
    const iframe_box = $('.iframe_kh_wrapper');
    if (iframe_box) {
        $('.demo-slots-info, .demo-slots-button').on('click', function () {
            $('.demo-slots-info, .demo-slots-button').fadeOut(500);
            iframe_box.fadeIn(500);
        });
    }

    $('.slot-footer-values').each(function() {
        var element = $(this);
        if (element.height() > 22) {
          element.css('font-size', '14px');
          element.css('height', '22px');
        }
      });
});
